var map = {
	"./diferente-iqos24plus/differences2.jpg": 2682,
	"./diferente-iqos3duo/differences1.jpg": 2333,
	"./diferente/differences1.jpg": 5199,
	"./diferente/differences2.jpg": 4655,
	"./iqos-2-4-plus/charging.jpg": 772,
	"./iqos-2-4-plus/cleaning.jpg": 7534,
	"./iqos-2-4-plus/setup.jpg": 4065,
	"./iqos-2-4-plus/unboxing.jpg": 4914,
	"./iqos-3-duo/charger-serial-no.jpg": 4960,
	"./iqos-3-duo/charging.jpg": 8966,
	"./iqos-3-duo/claim-heets.jpg": 9654,
	"./iqos-3-duo/cleaning.jpg": 1675,
	"./iqos-3-duo/identify-code.jpg": 802,
	"./iqos-3-duo/pen-serial-no.jpg": 2702,
	"./iqos-3-duo/register-codes.jpg": 8291,
	"./iqos-3-duo/setup.jpg": 240,
	"./iqos-3-duo/unboxing.jpg": 1134,
	"./iqos-3-multi/charging.jpg": 1199,
	"./iqos-3-multi/cleaning.jpg": 8045,
	"./iqos-3-multi/setup.jpg": 160,
	"./iqos-3-multi/unboxing.jpg": 8891,
	"./iqos-3/charging.jpg": 9757,
	"./iqos-3/cleaning.jpg": 6233,
	"./iqos-3/setup.jpg": 8247,
	"./iqos-3/unboxing.jpg": 3955,
	"./iqos-iluma-one/charging.jpg": 6858,
	"./iqos-iluma-one/setup.jpg": 865,
	"./iqos-iluma-prime/charging.jpg": 698,
	"./iqos-iluma-prime/consumables.jpg": 634,
	"./iqos-iluma-prime/customize.jpg": 3486,
	"./iqos-iluma-prime/setup.jpg": 868,
	"./iqos-iluma/charging.jpg": 6829,
	"./iqos-iluma/consumables.jpg": 4596,
	"./iqos-iluma/customize.jpg": 968,
	"./iqos-iluma/setup.jpg": 6764,
	"./iqos-originals-duo/charging.jpg": 5007,
	"./iqos-originals-duo/cleaning.jpg": 2010,
	"./iqos-originals-duo/setup.jpg": 5612,
	"./iqos-originals-duo/unboxing.jpg": 1368,
	"./iqos-originals-one/charging.jpg": 4335,
	"./iqos-originals-one/cleaning.jpg": 236,
	"./iqos-originals-one/setup.jpg": 1246,
	"./iqos-originals-one/unboxing.jpg": 5269,
	"./lil-solid/charging.jpg": 5975,
	"./lil-solid/cleaning.jpg": 4430,
	"./lil-solid/setup.jpg": 328,
	"./lil-solid/unboxing.jpg": 5718,
	"./noul-iqos-2-4-plus/charging.jpg": 3173,
	"./noul-iqos-2-4-plus/cleaning.jpg": 7736,
	"./noul-iqos-2-4-plus/setup.jpg": 8688,
	"./noul-iqos-2-4-plus/unboxing.jpg": 5935,
	"./sfaturi/connect.jpg": 8914,
	"./sfaturi/customize1.jpg": 3701,
	"./sfaturi/simplify.jpg": 581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8826;